import { notFound } from "../utils/notFoundImage";

export function generateCardForCategory(cat, isModal = false) {
    const col = document.createElement("div");
    col.classList.add("col", "mb-3", "animate-up-3");

    const imgSrc = cat.image || "";

    const attributes = {
        href: isModal ? "#" : cat.searchLink,
        "data-modal": isModal ? "Edit" : null,
        "data-category-id": cat.id,
        "data-category-name": isModal ? cat.categoryName : null,
        "data-provided-categories": isModal? JSON.stringify(cat.providerCategories) : null,
        "data-category-image": isModal ? imgSrc : null,
    };

    var attrs = Object.entries(attributes)
        .map(([name, val]) => val ? `${name}="${val}"`: null)
        .filter(x => x);

    col.innerHTML = `<div id="${cat.id}" class="card shadow h-100 bg-gray-200 border-gray-300">
        <a ${attrs.join(" ")}>
            <img class="cover card-img-top rounded-top" style="height: 260px;" src="${imgSrc}" onerror="this.src='${notFound}';" alt="${cat.categoryName} category image">
            <div class="card-body d-flex flex-column border-top p-4">
                <p class="card-title h5">${cat.categoryName}</p>
            </div>
        </a>
    </div>`;

    return col;
}

export function generateModalCard(cat){
    return generateCardForCategory(cat, true);
}

export function updateCategoryCard(cat, eleToAddTo, modalEle, isModal = false) {
    const cardLink = document.querySelector(`div.col div.card a[data-category-id="${cat.id}"]`);

    if (!cardLink) {
        if(eleToAddTo){
            eleToAddTo.appendChild(generateCardForCategory(cat, isModal));    
        }
        //document.getElementById("currentCategoryCards").appendChild(generateCardForCategory(cat));
        return;
    }

    cardLink.setAttribute("data-category-name", cat.categoryName);
    cardLink.setAttribute("data-provided-categories", JSON.stringify(cat.providerCategories));

    if (cat.image) {
        cardLink.setAttribute("data-category-image", cat.image);
        cardLink.querySelector("img").src = cat.image;
    } else if (modalEle?.querySelector("form [data-file-type]")?.dataset.fileType == "delete") {
        cardLink.setAttribute("data-category-image", "");
        cardLink.querySelector("img").src = notFound;
    }

    cardLink.querySelector("img").alt = cat.categoryName + " category image";

    cardLink.querySelector("p.h5").innerText = cat.categoryName;
}